// Translation manager
// Eenvoudige i18n manager voor alleen Spaans
class I18nManager {
  constructor() {
    this.currentLang = "es";
    this.translations = {};
    document.documentElement.lang = "es";
  }

  getText(key) {
    // Geen vertalingen, geef gewoon de key terug
    return key;
  }

  updatePageTexts() {
    // Update alle elementen met data-i18n, maar gebruik gewoon de key
    document.querySelectorAll("[data-i18n]").forEach((element) => {
      const key = element.getAttribute("data-i18n");
      if (
        element.tagName === "INPUT" &&
        (element.type === "text" || element.type === "email")
      ) {
        element.placeholder = key;
      } else if (element.tagName === "INPUT" && element.type === "submit") {
        element.value = key;
      } else {
        element.textContent = key;
      }
    });
    // Update title en meta description
    document.title = `CEE España`;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.content = "Certificados de Eficiencia Energética para viviendas en España";
    }
  }
}

// Initialiseer en exporteer i18n manager
const i18n = new I18nManager();
window.i18n = i18n;

export default i18n;

export { I18nManager };
